var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3738 10.9596C11.9832 10.569 11.3501 10.569 10.9596 10.9596C10.569 11.3501 10.569 11.9832 10.9596 12.3738L12.3738 10.9596ZM16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L16.2929 17.7071ZM7.22222 12.4444C4.33807 12.4444 2 10.1064 2 7.22222H0C0 11.2109 3.2335 14.4444 7.22222 14.4444V12.4444ZM2 7.22222C2 4.33807 4.33807 2 7.22222 2V0C3.2335 0 0 3.2335 0 7.22222H2ZM7.22222 2C10.1064 2 12.4444 4.33807 12.4444 7.22222H14.4444C14.4444 3.2335 11.2109 0 7.22222 0V2ZM12.4444 7.22222C12.4444 10.1064 10.1064 12.4444 7.22222 12.4444V14.4444C11.2109 14.4444 14.4444 11.2109 14.4444 7.22222H12.4444ZM10.9596 12.3738L16.2929 17.7071L17.7071 16.2929L12.3738 10.9596L10.9596 12.3738Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.b16b646e9d8f2afa56b41a9f0ab69c80.svg";
export { ForwardRef as ReactComponent };